import { AllContent, RawContentItem } from './bundle.types';

export const allowedContentTypes = [
  'ContentLink',
  'ContentPDF',
  'ContentSlides',
  'ContentLegacyGuide',
  'ContentVideo',
];

export const toAllContent = (rawContent: Array<RawContentItem>): AllContent =>
  rawContent.map((c) => ({
    id: c.value.id,
    name: c.value?.title || c.value?.url || 'Item',
    isPublished: !!c.value.isPublished,
  }));

export const toSellableContent = (
  rawContent: Array<RawContentItem>,
): AllContent =>
  rawContent
    .filter((c) => !c.value.isArchived)
    .map((c) => ({
      id: c.value.id,
      name: c.value?.title || c.value?.url || 'Item',
      isPublished: !!c.value.isPublished,
    }));

export const convertDollarsToCents = (price: string): number => {
  if (!price.includes('.')) return parseInt(price) * 100;

  const [int, dec] = price.split('.');
  return parseInt(int) * 100 + parseInt(dec.padEnd(2, '0'));
};
